export const resourcesTypes = {
  HUMAN: 'HUMAN',
  MATERIAL: 'MATERIAL'
}
